import { useEffect } from "react";
import { formatDocumentTitle, useSiteSettings } from "../context/SiteSettingsContext";

export default function useDocumentTitle(pageTitle) {
  const { siteIdentity } = useSiteSettings();

  useEffect(() => {
    const nextTitle = formatDocumentTitle(siteIdentity, pageTitle);
    document.title = nextTitle;
    return () => {
      document.title = siteIdentity || "Søren Kølbæk";
    };
  }, [siteIdentity, pageTitle]);
}
